/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/


import { Button, Dialog, DialogContent, Divider, IconButton } from '@mui/material';
import React from 'react';
import './ConfirmationBox.scss'
import CloseIcon from '@mui/icons-material/Close';

export const ConfirmationBox: React.FC<any> = ({ openConfirmation, closeConfirmation, msgConfig, children, additionalFooterActions, hidePrimaryButton }) => {
	const [open, setOpen] = React.useState(openConfirmation);

	const handleNo = () => {
		setOpen(false);
		closeConfirmation(false);
	};

	const handleYes = () => {
		setOpen(false);
		closeConfirmation(true);
	};

	return (
		<div className='confirmationPopup'>
			<Dialog
				open={open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<div className="titleTextConfirmWrapper">
					<span className="titleTextConfirm">
						{msgConfig?.popupTitle}
					</span>
					<div className='closeIconWrapper'>
						<IconButton
							aria-label="close"
							onClick={handleNo}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
					</div>
				</div >
				<Divider />
				<DialogContent >
					<div className="descWrapper" style={{ width: hidePrimaryButton ? '400px !important' : '300px !important' }}>
						<span className='titleDescConfirm'>
							{msgConfig?.popupDesc}
						</span>
					</div>
					{children}
				</DialogContent>
				<div className="popupActions">
					<div className="popupActionsWrapper" style={{ justifyContent: hidePrimaryButton ? 'center' : 'space-between'}}>
					 {!hidePrimaryButton && (
							<Button className='secondaryBtn'
								onClick={handleNo} style={{ textTransform: "none" }}
							>
								{msgConfig?.secondaryBtnTxt ? msgConfig?.secondaryBtnTxt : 'No'}
							</Button>)}
						{additionalFooterActions}
						{!hidePrimaryButton && (
							<Button className="primeryBtn" onClick={handleYes} type="submit" style={{ textTransform: "none" }}>
								{msgConfig?.primaryBtnTxt ? msgConfig?.primaryBtnTxt : 'Yes'}
							</Button>
						)}
					</div>
				</div>
			</Dialog>
		</div>
	)
}